<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12 mt-5 show-desktop">
                <h2 class="big-title color-white f-w-700">
                    Vantagens de ser um  fraqueado Ponto Fácil
                </h2>
            </div>
            <div class="col-md-12 show-mobile flex j-c-center">
                <h2 class="big-title color-white f-w-700 text-center">
                    Vantagens <br> de ser um <br> fraqueado <br> Ponto Fácil
                </h2>
            </div>
            
            <div class="flex f-w flex j-c-center content">
                <div class="father-circle" v-for="(item, index) in avantages" :key="index">                    
                    <div class="circle_I flex j-c-center">
                            <div class="circle_II bg-color-F38235 relative text-center">
                                <div class="flex j-c-center title-in-circle absolute">
                                    <div>
                                        <div>
                                            <img class="img-responsive" :src="item.img" alt="">
                                        </div>
                                        <div>
                                            <h2 class="color-white other-h2">{{item.label}}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .father-circle{
        margin: 10px;
        z-index: 2;
    }
    .circle_I{
        height: 250px;
        width: 250px;
        border: 3px solid #E0A638;
    }
    .circle_II{
        height: 225px;
        width: 225px;
        border: 4px solid #fff;
    }

    .circle_I, .circle_II{
        border-radius: 100%;
    }

    .circle_I h2{
        font-size: 16px;
        padding: 10px 20px;
        margin-top: 10px;
    }

    .title-in-circle{
        bottom: 15%;
        width: 100%
    }

    .f-w{
        -ms-flex-wrap: wrap;
            flex-wrap: wrap
    }

    .big-title{
        margin-bottom: 50px
    }

    .father-circle:last-child .circle_II{
        z-index: 50;
    }

    .content{
        padding-bottom: 100px;
    }

    .circle_II:hover img {
        transform: scale(1.3);
    }

    img{
        height: 80px
    }

    h2{
        line-height: 1.1!important
    }

    @media only screen and (max-width: 992px){
        .show-desktop h2{
            text-align: center;
        }
    }

    @media only screen and (max-width: 767px){

        .circle_I{
            height: 150px;
            width: 150px;
            border: 3px solid #E0A638;
        }
        .circle_II{
            height: 125px;
            width: 125px;
            border: 1px solid #fff;
        }

        h2.other-h2{
            font-size: 12px!important;
            padding: 0 5px!important
        }

        img{
            width: 50px;
            height: auto;
        }
    }

    
</style>

<script>
export default {
    data() {
        return {
            avantages:[
                {
                    label: "Marca forte e consolidada",
                    img: require('@/assets/associated/icons/icon-1.png'),
                },
                {
                    label: "Sistema de Atendimento e Gestão",
                    img: require('@/assets/associated/icons/icon-2.png'),
                },
                {
                    label: "Baixo custo de Implantação",
                    img: require('@/assets/associated/icons/icon-3.png'),
                },
                {
                    label: "Retorno rápido do seu investimento",
                    img: require('@/assets/associated/icons/icon-4.png'),
                },
                {
                    label: "Empreendendo em tecnologia",
                    img: require('@/assets/associated/icons/icon-5.png'),
                },
                {
                    label: "Suporte Ativo e Exclusivo",
                    img: require('@/assets/associated/icons/icon-6.png'),
                },
                {
                    label: "Diferenciação da concorrência",
                    img: require('@/assets/associated/icons/icon-7.png'),
                },
                {
                    label: "Investimento em Marketing",
                    img: require('@/assets/associated/icons/icon-8.png'),
                },
            ]
        }
    },
    
}
</script>